// TravelProcess.js
import React from 'react';
import { motion } from 'framer-motion';
import { Phone, FileText, Search, CheckCircle, Send, RefreshCw } from 'lucide-react';

const TravelProcess = () => {
  const steps = [
    {
      id: 1,
      icon: Phone,
      title: "Triage (free, ~10 minutes)",
      description: "Your goal, destination, timing, and prior history."
    },
    {
      id: 2,
      icon: FileText,
      title: "Plan & Checklist",
      description: "We confirm the route and send a personalized checklist with templates and formatting standards."
    },
    {
      id: 3,
      icon: Search,
      title: "Gather & Verify",
      description: "You collect documents; where needed, our Verification team obtains evidence (employment/education/address/financial) with your consent."
    },
    {
      id: 4,
      icon: CheckCircle,
      title: "Assembly & QA",
      description: "We organize your file and run a final admin quality check against destination requirements."
    },
    {
      id: 5,
      icon: Send,
      title: "Submit & Prepare",
      description: "You submit; we support appointment booking (where available) and run a mock interview."
    },
    {
      id: 6,
      icon: RefreshCw,
      title: "Follow-up",
      description: "We help organize responses to any additional document requests and advise on documentation steps after a decision."
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            How it works
          </h2>
        </motion.div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <motion.div
                key={step.id}
                className="text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                {/* Icon */}
                <div className="flex flex-col items-center mb-6">
                  <div className="w-16 h-16 bg-acYellow rounded-full flex items-center justify-center mb-4">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-inter font-bold text-acBlack mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TravelProcess;
